//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import fileUpload from '@/components/file-upload'
import DivSpan from '@/components/DivSpan'


export default {
  name: "sample-view",
  components: {
    fileUpload,
    DivSpan,
  },
  props: ['dataId','dataImg','editable'],
  data() {
    return {
      baseDto: {},
      list: [],
      viewItemDto: {},
      gridList: [
        {icon:require('@/assets/icon/supplier/supplier_base_data.png'),label:'基本信息'},
        {icon:require('@/assets/icon/supplier/bidding_detail.png'),label:'商品明细'},
        {icon:require('@/assets/icon/supplier/com_order_flow.png'),label:'流程信息'},
      ],
      confirmList: [{name:'通过',value:'pass'},{name:'不通过',value:'nopass'}],
      isVisible: false,
      showContent: false,
      showContent2: false,
      showContent3: false,
      bigImg:false,
      index: 1,
      i: 1,
    }
  },
  methods: {
    changedataShow(i) {
      if (this.list[i].contentShow) {
        this.$set(this.list[i], 'contentShow', false);
        return;
      }
      this.$set(this.list[i], 'contentShow', true);
    },
    formData(){
      return this.baseDto
    },
    valid(){
      return true
    },
    itemTab(index) {
      this.index = index;
      if(index === 3){
        this.$emit('changeFlowInfo',true);
      }else{
        this.$emit('changeFlowInfo',false);
      }
    },
    itemView(item,i) {
      this.isVisible = !this.isVisible;
      this.i=i;
      this.viewItemDto = item;
    },
    getBaseDto() {
      this.$loadingShow();
      this.$get('api/SupProductLib/' + this.dataId).then((data) => {
        if (data) {
          this.baseDto = data;
          this.list = data.pruductDts;
        }
        this.$loadingHide();
      }).catch((error) => {
        this.$loadingHide();
      });
    }
  },
  mounted(){
    if(this.dataId){
      this.getBaseDto()
    }
  },
  watch:{
    dataId(){
      if(this.dataId){
        this.getBaseDto()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/supplier/goods/sup-goods-detail.vue